import {
  CustomerStatusEnum,
  CustomerStatusTypes,
  ICustomerStatusDTO,
} from "@hooks/dtos/customer/ICustomerDTO";

/* eslint-disable no-param-reassign */
const customerStatusTypes: ICustomerStatusDTO[] = [
  {
    status: CustomerStatusEnum.ACTIVE,
    text: "Conta ativa",
    title: "Ativo",
    color: "success",
  },
  {
    status: CustomerStatusEnum.INACTIVE,
    text: "Conta inativa",
    title: "Inativo",
    color: "danger",
  },
  {
    status: CustomerStatusEnum.PENDING,
    text: "Conta pendente de aprovação",
    title: "Pendente",
    color: "danger",
  },
  {
    status: CustomerStatusEnum.DELETED,
    text: "Conta excluída",
    title: "Excluído",
    color: "danger",
  },
];

function getCustomerStatus(status: CustomerStatusTypes): ICustomerStatusDTO {
  let ret = customerStatusTypes.find(
    (eventStatusType) => eventStatusType.status === status,
  );
  if (!ret)
    ret = {
      status: "undefined",
      text: "Error",
      title: "Error",
      color: "danger",
    };
  return ret;
}

export { customerStatusTypes, getCustomerStatus };
